import RecoveryWorkOrder from './RecoveryWorkOrder.vue'

export default RecoveryWorkOrder 


// WEBPACK FOOTER //
// ./src/pages/RecoveryWorkOrder/index.js